import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

let adminToken: string | null = null;
let customerToken: string | null = null;

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

function isAdminRequest(url?: string, method?: string): boolean {
  if (!url) return false;
  if (url.includes('/api/admin')) return true;
  // File upload/delete are admin-only but live under /api/files
  const m = (method ?? 'get').toLowerCase();
  if (url.includes('/api/files') && m !== 'get') return true;
  return false;
}

apiClient.interceptors.request.use((config) => {
  const token = isAdminRequest(config.url, config.method) ? adminToken : customerToken;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  } else {
    config.headers.delete('Authorization');
  }
  return config;
});

export function setAdminToken(token: string | null) {
  adminToken = token;
}

export function setCustomerToken(token: string | null) {
  customerToken = token;
}

export function setAuthToken(token: string | null) {
  customerToken = token;
}

export { API_URL };
